import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Button, Card, CardActionArea, CardContent, CircularProgress, Grid, Typography,
} from '@mui/material';
import PetsIcon from '@mui/icons-material/Pets';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GrassIcon from '@mui/icons-material/Grass';
import { useAuth } from '../AuthContext';
import api from '../api';

export default function Home() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loadingStats, setLoadingStats] = useState(true);

  useEffect(() => {
    api.get('/cows/stats/')
      .then((res) => setStats(res.data))
      .finally(() => setLoadingStats(false));
  }, []);

  const quickLinks = [
    { label: 'Herd', sub: 'View & manage cattle', icon: <PetsIcon fontSize="large" />, path: '/herd' },
    { label: 'Receipts', sub: 'Log shared expenses', icon: <ReceiptIcon fontSize="large" />, path: '/receipts' },
    { label: 'Balances', sub: 'Who owes whom', icon: <AccountBalanceIcon fontSize="large" />, path: '/balances' },
  ];

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 900, mx: 'auto' }}>
      <Box display="flex" alignItems="center" gap={1.5} mb={1}>
        <GrassIcon color="primary" sx={{ fontSize: 40 }} />
        <Box>
          <Typography variant="h4" fontWeight={700}>Wood Family Farm</Typography>
          <Typography variant="body1" color="text.secondary">
            Welcome back, {user?.username}
          </Typography>
        </Box>
      </Box>

      {/* Herd summary */}
      <Box sx={{ mt: 3, mb: 4, p: 2, bgcolor: 'primary.main', borderRadius: 2, color: 'white' }}>
        {loadingStats ? (
          <CircularProgress size={24} sx={{ color: 'white' }} />
        ) : stats ? (
          <Box display="flex" flexWrap="wrap" gap={4} alignItems="center">
            <Box>
              <Typography variant="h3" fontWeight={700}>{stats.total_head}</Typography>
              <Typography variant="body2" sx={{ opacity: 0.85 }}>Total Head</Typography>
            </Box>
            {Object.entries(stats)
              .filter(([k]) => !['Farm', 'total_head'].includes(k))
              .map(([name, data]) => (
                <Box key={name}>
                  <Typography variant="h5" fontWeight={600}>{data.head_count}</Typography>
                  <Typography variant="body2" sx={{ opacity: 0.85 }}>{name}</Typography>
                  <Typography variant="caption" sx={{ opacity: 0.7 }}>
                    {data.expense_pct?.toFixed(1)}% expenses
                  </Typography>
                </Box>
              ))}
            <Button
              variant="outlined"
              sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.6)', ml: 'auto' }}
              onClick={() => navigate('/herd/new')}
            >
              + Add Cow
            </Button>
          </Box>
        ) : null}
      </Box>

      {/* Quick links */}
      <Grid container spacing={2}>
        {quickLinks.map(({ label, sub, icon, path }) => (
          <Grid item xs={12} sm={4} key={path}>
            <Card variant="outlined">
              <CardActionArea onClick={() => navigate(path)} sx={{ p: 2 }}>
                <CardContent sx={{ textAlign: 'center' }}>
                  <Box color="primary.main" mb={1}>{icon}</Box>
                  <Typography variant="h6" fontWeight={700}>{label}</Typography>
                  <Typography variant="body2" color="text.secondary">{sub}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
